export default __webpack_public_path__ + "static/media/List-documentation.48bd433e.md";